import Vue from 'vue'

Vue.filter('money', function (value) {
    return new Intl.NumberFormat('fr-CA', { style: 'currency', currency: 'CAD', currencyDisplay: "narrowSymbol" }).format(value)
})